module.exports = __webpack_public_path__ + "static/media/blog2.cd422a35.webp";